import {
  AnnotationsTooltipConfig,
  AnnotationsTooltipProps,
} from '../../core/components/annotations/components/tooltip/types/annotations-tooltip-props.js';
import { DEFAULT_TOOLTIP_HIDDEN } from '../constants.js';

/**
 * Populates missing tooltip props with defaults
 *
 * @param tooltipProps -
 * @param tooltipConfig -
 */
export const populateMissingTooltipProps = (
  tooltipProps: AnnotationsTooltipProps,
  tooltipConfig?: AnnotationsTooltipProps,
): AnnotationsTooltipConfig => {
  const { children, ...restProps } = tooltipProps;

  const config = {
    hidden: tooltipConfig?.hidden ?? DEFAULT_TOOLTIP_HIDDEN,
  };

  return { ...config, ...restProps, template: children };
};
